import { PropsWithChildren } from 'react';
import { FormRow } from '@features/components/CaseFormBlocks/components';

export const EtaFormRow = ({ label, children }: PropsWithChildren<{ label: string }>) => (
  <FormRow title={label}>
    <span className="text-m-m">{children ?? '-'}</span>
  </FormRow>
);
